Ext.ns('mx.comp');

mx.comp.MapSelectCombo = Ext.extend(mx.comp.LinkedComboBox, {
    editable: false,
    forceSelection: true,
    fieldLabel: 'Map provider',
    emptyText: 'Select a provider...',
    blankText: 'Map provider is a required field',
    valueField: 'id',
    displayField: 'name',
    params: {
        mapDataAvailable: true,
    },
    url: null,
    initComponent: function() {
        this.store = mx.data.MapProvider.newStore({
            params: this.params,
            url: this.url,
        });
        mx.comp.MapSelectCombo.superclass.initComponent.call(this);
    },
});

Ext.reg('mx-mapcombo', mx.comp.MapSelectCombo);
